import { env, ui } from '#config'
import { toggles } from '#features'
import { Toggles } from '#features.ui'
import RavGuest from '#guest/rav-guest'
import en from "#locale/en_translation.json"
import fr from "#locale/fr_translation.json"
import { Search } from '#search/provider'
import { Vessels } from '#vessel/vessels'
import { Application } from 'apprise-ui/application'
import { Client } from 'apprise-frontend-core/client/client'
import { Intl } from 'apprise-frontend-core/intl/intl'
import { useT } from 'apprise-frontend-core/intl/language'
import { useComponentBridge } from 'apprise-frontend-core/utils/bridge'
import { Events } from 'apprise-frontend-events/events'
import { UpgradeObserver } from 'apprise-frontend-events/upgradeobserver'
import { useOracle } from 'apprise-frontend-iam/authz/oracle'
import { Login } from 'apprise-frontend-iam/login/login'
import { Tenants } from 'apprise-frontend-iam/tenant/tenants'
import { Settings } from 'apprise-frontend-streams/settings/settings'
import { Tags } from 'apprise-frontend-tags/tags'
import { lazy, Suspense } from 'react'

export const Rav = () => {

    return <Application env={env} ui={ui}>
            <Intl translations={{ en, fr }} >
                <Client>
                    <Login mode='guest-allowed'>
                        <Events>
                            <Settings>
                                <Tags>
                                    <Tenants>
                                        <Search>
                                            <Vessels>
                                                <UpgradeObserver topic='console'>
                                                    {/* above the guest/logged split, so guests get the list too. logged users get the
                                                        beta-tester policy from Users; guests keep the core default, which turns listed
                                                        toggles off everywhere: they see a feature only once released in the Dev settings. */}
                                                    <Toggles toggles={toggles}>
                                                        <RavRouter />
                                                    </Toggles>
                                                </UpgradeObserver>
                                            </Vessels>
                                        </Search>
                                    </Tenants>
                                </Tags>
                            </Settings>
                        </Events>
                    </Login>
                </Client>
            </Intl>
    </Application >
}

// const RavGuest = lazy(() => import('./guest/rav-guest'))
const RavLogged = lazy(() => import('./rav-logged'))


export const RavRouter = () => {

    const t = useT()

    const oracle = useOracle()

    const { Indicator } = useComponentBridge()

    return oracle.isGuest() ?

        <RavGuest />

        :

        <Suspense fallback={<Indicator msg={t('rav.load_ui')} waiting={true} />} >
            <RavLogged />
        </Suspense>
}